<template>
  <div>
    <div v-if="showGoogleAds&&adsCard" style="text-align: center;">
      <a
        :href="adsCard.website"
        target="_blank"
        v-if="!adsCard.advertisment_location.google_on"
        id="imageListing"
        @click="updateBannerHit(adsCard)"
      >
        <b-img
          :src="adsCard.image"
          class="img-card"
          style="max-width: 100%; height: auto; width:100%;"
          :alt="adsCard.website"
						
        ></b-img>
        <!-- /images/Kasikorn-Banner.png -->
      </a>
      <Adsense
            data-ad-test="false"
            v-else
            in-style="display:inline-block;width:728px;height:90px"
            :data-ad-client="$root.googleClientId"
            :data-ad-slot="adsCard.advertisment_location.google_ad_key"
          >
          </Adsense>
    </div>
    
    <a
      id="listingDetail"
      v-else
      class="list-item-search"
      :href="url?url:$i18nRoute({ name: 'listing-detail' }, id)"
      :to="$i18nRoute({ name: 'listing-detail' }, id)"
      :class="{ 'bg-yellow': isHighlight, 'bg-light-green': isFeature }"
      :target="target"
    >
      <div class="right-side">
        <div v-if="isQuickSale" class="hot">
          <div>{{ $t("packages.quickSale.title") }}</div>
        </div>
        <b-card-img :src="urlImage.replace('832x468', '250x141')" class="img-card"></b-card-img>
        <!-- <b-avatar :size="48" class="bg-transparent" src="/images/card1.png"></b-avatar> -->
        <div class="agency-logo" v-if="agency_profile_image"
              :style="{ backgroundImage: 'url(' + agency_profile_image + ')' }"
        ></div>
        <div v-if="isFeature" class="bookmark">
          <div class="start-while">
            <StarIcon />
          </div>
        </div>
      </div>
      <ul class="ul-list-item">
        <li class="location-div">
          <span class="location">{{ district }} > {{ province }}</span>
          <span
            @click.prevent="favorite"
            class="card-favorite d-none d-lg-block"
          >
            <IconFavoriteBorder v-if="!isFavorite" />
            <FavoriteIcon v-else />
          </span>
        </li>
        <li class="li-title">
          {{ funcSubString(title, 50) }}
        </li>
        <li class="description d-none d-lg-inline-block">
          {{ description.substr(0, 150) }}...
        </li>
        <li class="price-row">
           
          <span class="price"  v-if="!salaryType&&!minSalary">
            {{ price.toLocaleString("th-TH") }} {{ $t('baht') }}  
          </span>

          <!--job category-->
          <span class="price"  v-if="!salaryType&&minSalary">
            
              <span v-if="minSalary">
                 {{minSalary}} {{ $t('baht') }} - 
              </span>
              {{ price.toLocaleString("th-TH") }} {{ $t('baht') }}  
          </span>
          <!--job category-->
          <span class="card-cost" v-if="salaryType&&!minSalary">
            {{ salaryType }}
          </span>
          <span class="span-negotiable d-none d-lg-block" v-if="isNegotiable">{{
            $t("packages.negotiable.title")
          }}</span>
        </li>
        <li class="price-row d-flex d-lg-none">
          <span class="span-negotiable" v-if="isNegotiable">{{
            $t("packages.negotiable.title")
          }}</span>
          <span @click.prevent="favorite" class="card-favorite">
            <IconFavoriteBorder v-if="!isFavorite" />
            <FavoriteIcon v-else />
          </span>
        </li>
      </ul>
      <div class="clearfix"></div>
      <b-toast
        id="favourite-toast"
        variant="warning"
        solid
        ref="favourite-toast"
      >
        <template v-slot:toast-title>
          <div class="d-flex flex-grow-1 align-items-baseline">
            <b-img
              blank
              blank-color="#dc3545"
              class="mr-2"
              width="12"
              height="12"
              :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"
            ></b-img>
            <strong class="mr-auto">{{ $t("favourite.title") }}</strong>
          </div>
        </template>
        {{ $t("favourite.errLogin") }}
      </b-toast>
    </a>
  </div>
</template>
<script>
import StarIcon from "vue-material-design-icons/Star.vue";
import IconFavoriteBorder from "vue-material-design-icons/HeartOutline.vue";
import FavoriteIcon from "vue-material-design-icons/Heart.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "listItemSearch",
  components: {
    StarIcon,
    IconFavoriteBorder,
    FavoriteIcon
  },
  props: {
    color: {
      type: String,
      default: ""
    },
    urlImage: {
      type: String,
      default: "/images/card1.png"
    },
    description: {
      type: String,
      default: ""
    },
    price: {
      type: Number,
      default: 0
    },
    province: {
      type: String,
      default: ""
    },
    district: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    id: {
      type: Number,
      default: 0
    },
    listingPremium: {
      type: Array,
      default: () => []
    },
    listing_attributes_details: {
      type: Array,
      default: () => []
    },
    showGoogleAds: {
      type: Boolean,
      default: false
    },
    typeAds: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: '_self'
    },
    fav: {
      type: Boolean,
      default: false
    },
    agency_profile_image: {
      type: String,
    },
  },
  data() {
    return {
      minSalary:0,
      salaryType:null,
      isFavorite: false,
      isQuickSale: false,
      isNegotiable: false,
      isFeature: false,
      isHighlight: false,
      itemFavourite: null,
      adsCard: {
        website: "#",
        image: "",
        advertisment_location:{
          google_on: false
        }
      },
      idTypeAds: {
        feature: 4,
        marketPlace: 5,
        realEstate: 6,
        cars: 7,
        jobs: 8,
        search: 9
      },
      locationIdForCardAds: 0
    };
  },
  watch: {
     listing_attributes_details:function(val){
      this.getListingAttr();
    }
  },
  created() {
    this.checkPackage();
    if(this.id){
      this.isFavorite=this.fav;  
    }
    let locationIdForCardAds = 12;
      
      if (
        (this.$router.history.current.path == "/th/search/" ||
          this.$router.history.current.path == "/en/search/") && this.typeAds == "marketPlace"
      ) {
        locationIdForCardAds = 12;
      }
      if (
        (this.$router.history.current.path == "/th/search/" ||
          this.$router.history.current.path == "/en/search/") &&this.typeAds == "realEstate"
      ) {
        locationIdForCardAds = 21;
      }
      if (
        (this.$router.history.current.path == "/th/search/" ||
          this.$router.history.current.path == "/en/search/") &&this.typeAds == "carsEngines"
      ) {
        locationIdForCardAds = 30;
      }
      if (
        (this.$router.history.current.path == "/th/search/" ||
          this.$router.history.current.path == "/en/search/") &&this.typeAds == "findJob"
      ) {
        locationIdForCardAds = 39;
      }
      
      if (this.locationIdForCardAds != locationIdForCardAds&&this.showGoogleAds) {
        this.locationIdForCardAds = locationIdForCardAds;
        this.getAds(locationIdForCardAds);
      }
      this.getListingAttr();
  },
  methods: {
    ...mapActions("AdsController", [
      "GETADS_FOR_PUBLIC_WEBSITE",
      "CLICK_BANNERADS"
    ]),
    ...mapActions("FavouriteController", [
      "CREATE_FAVOURITES_USER",
      "DELETE_FAVOURITES_USER"
    ]),
     //job category
    getListingAttr(){
      this.minSalary=0;
      this.salaryType=null;
      this.listing_attributes_details.forEach((element)=>{
        
        if(element.attr_id==15){
          this.minSalary=element.value?element.value:0;
        }
        if(element.attr_id==18&&element.pre_values_id!=56){
          this.salaryType=element.listing_pre_value.value?element.listing_pre_value.value:null;
        }
      })
    },
    updateBannerHit(item) {
      if (item.id) {
        this.CLICK_BANNERADS(item.id);
      }
    },
    createFavourites() {
      if (this.$root.isAuthenticated && this.id) {
        this.CREATE_FAVOURITES_USER({
          listing_id: this.id
        });
      }
    },
    deleteFavourites() {
      if (this.$root.isAuthenticated ) {
        this.DELETE_FAVOURITES_USER({
          id: this.id
        });
      }
    },
    favorite() {
      if (!this.$root.isAuthenticated) return this.$refs["favourite-toast"].show();
      this.isFavorite = !this.isFavorite;
      if (this.isFavorite) {
        this.createFavourites();
      } else {
        this.deleteFavourites();
      }
    },
    async checkPackage() {
      this.isHighlight = false;
      this.isFeature = false;
      this.isQuickSale = false;
      this.isNegotiable = false;
      return await Promise.all(
        await this.listingPremium.map(data => {
          if (data.package_id == 1) {
            this.isHighlight = true;
            this.isFeature = true;
          }
          if (data.package_id == 3) {
            this.isQuickSale = true;
          }
          if (data.package_id == 4) {
            this.isNegotiable = true;
          }
          if (data.package_id == 5) {
            this.isHighlight = true;
          }
        })
      );
    },
    funcSubString(string, number) {
      let subStr = "";
      if (string.length > number && string.indexOf(" ") !== -1) {
        subStr =
          string.substring(0, string.substring(0, number).lastIndexOf(" ")) +
          " ...";
      } else {
        subStr = string;
      }
      return subStr.toString();
    },
    getAds(locationId) {
      //
      this.GETADS_FOR_PUBLIC_WEBSITE({ id: locationId })
        .then(result => {
          
          if (result.data) {
              this.adsCard = result.data;
            
          }
        })
        .catch(err => {
          
        });
    }
  }
};
</script>
<style lang="scss">
@import "style";
</style>